import polite from './polite.wav'

export default function playNotification() {
    var audio = new Audio(polite);
    audio.play();
}
